(() => {
  'use strict';
  const root = window.Shopify?.routes?.root || '/';
  const $ = (s, p = document) => p.querySelector(s);
  const $$ = (s, p = document) => [...p.querySelectorAll(s)];
  let busy = false, cartUnconfirmed = false, searchController, quickController;
  const dialogOpeners = new WeakMap();
  const dialogTriggers = new WeakMap();
  const disabledBeforeUpdate = new Map();
  const approvedHandles = new Set(JSON.parse($('[data-approved-handles]')?.textContent || '[]'));
  let engagementProduct, engagementCart, engagementStop;
  try {engagementProduct = JSON.parse($('[data-engagement-product]')?.textContent || 'null');} catch { /* Tracking must not block shopping. */ }
  const engagementOnce = new Set();
  let variantChosen = false;
  function engagementAllowed() {
    const privacy = window.Shopify?.customerPrivacy;
    return privacy?.analyticsProcessingAllowed?.() === true && privacy?.marketingAllowed?.() === true && privacy?.saleOfDataAllowed?.() === true;
  }
  function engage(name, extra = {}, once = false) {
    if (!engagementAllowed() || (once && engagementOnce.has(name))) return false;
    const publish = window.Shopify?.analytics?.publish;
    if (!publish) return false;
    const product = extra.source === 'bag' ? null : engagementProduct;
    const id = $('[data-native-product] [data-native-variant]')?.value || product?.variant;
    const variant = product?.variants.find(v => v.id === id);
    const data = {name, source:'pdp', ...(product ? {product_id:'gid://shopify/Product/' + product.id,product_handle:product.handle,product_title:product.title,content_ids:[id],content_type:'product',currency:product.currency,...(variant ? {price:variant.price / 100,value:variant.price / 100} : {})} : {}), ...extra};
    try {
      // Shopify owns delivery/consent and standard events; this bus carries only engagement.
      const result = publish.call(window.Shopify.analytics, 'cfa:engagement', data);
      if (result === false) return false;
      if (once) engagementOnce.add(name);
      Promise.resolve(result).catch(() => {});
      return true;
    } catch {return false;}
  }
  function trackBag(name) {
    if (!engagementCart) return;
    const cart = engagementCart;
    engage(name, {source:'bag',content_ids:cart.items.map(item => String(item.variant_id)),currency:cart.currency,value:cart.total_price / 100,cart_value:cart.total_price / 100,item_count:cart.item_count});
  }
  function startEngagement() {
    engagementStop?.();engagementStop = undefined;
    if (!engagementProduct || !engagementAllowed()) return;
    const prices = $$('[data-native-product] [data-native-price]');
    const observer = new IntersectionObserver(entries => {
      if (document.visibilityState !== 'visible' || $('dialog[open]')) return;
      if (entries.some(entry => entry.isIntersecting && entry.intersectionRatio >= 0.6) && engage('PriceSeen', {}, true)) observer.disconnect();
    }, {threshold:0.6});
    for (const price of prices) observer.observe(price);
    const scroll = () => {
      if (document.visibilityState !== 'visible' || $('dialog[open]')) return;
      const max = document.documentElement.scrollHeight - innerHeight;
      if (max <= 0) return;
      const percent = scrollY / max * 100;
      for (const threshold of [25,50,75]) if (percent >= threshold) engage('PdpScrolled' + threshold, {}, true);
      if (percent >= 50 && engagementProduct.variants.length > 1 && !variantChosen) engage('PdpVariantUndecided', {option_count:engagementProduct.option_count}, true);
    };
    const timers = [15,60].map(seconds => setTimeout(() => {
      if (document.visibilityState === 'visible') engage('PdpTime' + seconds + 's', {}, true);
    }, seconds * 1000));
    const visible = () => {for (const price of prices) {observer.unobserve(price);observer.observe(price);}};
    window.addEventListener('scroll', scroll, {passive:true});
    document.addEventListener('visibilitychange', visible);
    document.addEventListener('close', visible, true);
    engagementStop = () => {observer.disconnect();timers.forEach(clearTimeout);window.removeEventListener('scroll',scroll);document.removeEventListener('visibilitychange',visible);document.removeEventListener('close',visible,true);};
  }
  document.addEventListener('visitorConsentCollected', startEngagement);
  startEngagement();
  const status = message => { $('#cfa-status').textContent = message; };
  function openDialog(name, trigger) {
    const dialog = $('#cfa-' + name);
    if (!dialog) return;
    if (name === 'privacy') syncPrivacyChoices();
    const parentDialog = trigger?.closest('dialog');
    const returnFocus = parentDialog ? dialogOpeners.get(parentDialog) || trigger : trigger || document.activeElement;
    for (const other of $$('dialog[open]')) {
      dialogOpeners.get(other)?.setAttribute('aria-expanded', 'false');
      dialogTriggers.get(other)?.setAttribute('aria-expanded', 'false');
      other.close();
    }
    dialogOpeners.set(dialog, returnFocus);
    dialogTriggers.set(dialog, trigger);
    dialog.showModal();
    document.documentElement.style.overflow = 'hidden';
    trigger?.setAttribute('aria-expanded', 'true');
    if (name === 'bag') trackBag('CartOpened');
    if (name === 'size') engage('SizeGuideOpened');
    if (name === 'zoom') engage('ZoomedPDP');
    if (name === 'search') $('[data-predictive-search]', dialog)?.focus();
  }
  for (const dialog of $$('dialog')) dialog.addEventListener('close', () => {
    // A close event can arrive after another modal (or this one) has opened.
    if (dialog.open) return;
    if (dialog.id === 'cfa-bag') trackBag('CartClosed');
    if (dialog.id === 'cfa-quick') quickController?.abort();
    let opener = dialogOpeners.get(dialog);
    if (dialog.id === 'cfa-zoom' && editorial?.type === 'glove') {
      if ($('.cfa-glove-hero')) {showPhoto(zoomIndex);opener = $(`.immersive-photo[data-photo-index="${zoomIndex}"]`);}
      else gloveState(zoomIndex);
    }
    opener?.setAttribute('aria-expanded', 'false');
    dialogTriggers.get(dialog)?.setAttribute('aria-expanded', 'false');
    if ($('dialog[open]')) return;
    document.documentElement.style.overflow = '';
    opener?.focus();
  });
  async function json(url, options = {}) {
    const controller = new AbortController();
    let timedOut = false;
    const abort = () => controller.abort();
    options.signal?.addEventListener('abort', abort, {once: true});
    if (options.signal?.aborted) abort();
    const timer = setTimeout(() => {timedOut = true;controller.abort();}, 20000);
    try {
      const response = await fetch(url, {credentials: 'same-origin', ...options, signal: controller.signal});
      let data;
      try {data = await response.json();}
      catch {throw new Error('The store is temporarily unavailable. Please wait a moment before reviewing your bag.');}
      if (!response.ok) throw new Error(data.description || data.message || 'Please try again. Your bag has not been confirmed.');
      return data;
    } catch (error) {
      if (timedOut) {
        const timeout = new Error('The update timed out. Wait a moment, then reload to confirm your bag.');
        timeout.unconfirmedMutation = options.method === 'POST';
        throw timeout;
      }
      throw error;
    } finally {
      clearTimeout(timer);
      options.signal?.removeEventListener('abort', abort);
    }
  }
  function bagError(message) {
    for (const error of $$('[data-bag-error]')) error.textContent = message;
    status(message);
  }
  function syncProductForm(form) {
    const select = $('[data-native-variant]', form), option = select?.selectedOptions[0];
    const available = !!(option?.value && !option.disabled);
    const hasAvailableSize = select && [...select.options].some(item => item.value && !item.disabled);
    const add = $('[name="add"]', form);
    if (add) {
      add.disabled = busy || cartUnconfirmed || !available;
      add.textContent = available ? 'Add to Bag' : option?.value || !hasAvailableSize ? 'Sold Out' : 'Select size';
    }
    const payment = $('[data-accelerated-checkout]', form);
    if (payment) {payment.hidden = !available;payment.inert = busy || cartUnconfirmed || !available;}
    const express = $('[data-express-checkout]', form);
    if (express) express.disabled = busy || cartUnconfirmed || !available;
    const link = $('[data-full-product]', form.closest('[data-quick-content]') || form);
    if (link && option?.value) {const url = new URL(link.href);url.searchParams.set('variant', option.value);link.href = url;}
    return available;
  }
  function setCartBusy(pending) {
    busy = pending;
    const locked = busy || cartUnconfirmed;
    const controls = $$('[data-cart-quantity],[data-cart-step],[data-cart-remove],button[name="checkout"],[data-native-product-form] button[type="submit"],[data-native-variant]');
    for (const control of controls) {
      if (locked) {
        if (!disabledBeforeUpdate.has(control)) disabledBeforeUpdate.set(control, control.disabled);
        control.disabled = true;
        control.setAttribute('aria-disabled', 'true');
      } else if (disabledBeforeUpdate.has(control)) {
        control.disabled = disabledBeforeUpdate.get(control);
        control.removeAttribute('aria-disabled');
      }
    }
    if (!locked) disabledBeforeUpdate.clear();
    for (const container of $$('[data-accelerated-checkout],[data-cart-wallets]')) {container.inert = locked;container.setAttribute('aria-busy',String(locked));}
    for (const form of $$('[data-cart-form],[data-native-product-form]')) form.setAttribute('aria-busy', String(busy));
    for (const form of $$('[data-native-product-form]')) syncProductForm(form);
  }
  async function refreshBag(sections) {
    if (typeof sections === 'string') sections = {'cart-drawer': sections};
    const page = $('[data-cart-page]');
    if (!sections?.['cart-drawer'] || (page && !sections?.['main-cart'])) sections = await json(root + 'cart?sections=cart-drawer,main-cart');
    const section = sections?.['cart-drawer'];
    if (!section) throw new Error('Bag update could not be displayed. View your bag to confirm it.');
    const doc = new DOMParser().parseFromString(section, 'text/html');
    const next = $('#cfa-bag', doc), current = $('#cfa-bag');
    if (!next || !current) throw new Error('Bag display unavailable. View your bag to confirm it.');
    const nextPage = page && $('[data-cart-page]', new DOMParser().parseFromString(sections['main-cart'], 'text/html'));
    if (page && !nextPage) throw new Error('Bag page unavailable. Reload to confirm your bag.');
    const cart = await json(root + 'cart.js');
    engagementCart = cart;
    current.innerHTML = next.innerHTML;
    if (page) page.innerHTML = nextPage.innerHTML;
    updateArrivalDates();
    cartUnconfirmed = false;
    setCartBusy(busy);
    for (const button of $$('[data-open-dialog="bag"]')) button.setAttribute('aria-label', `Open shopping bag, ${cart.item_count} items`);
    status(`${cart.item_count} items in your bag`);
    return cart;
  }
  // Cancel AJAX forms before Shopify's form listener; the successful fetch owns tracking.
  document.addEventListener('submit', async event => {
    if (event.target.matches('[data-cart-form]')) {
      if (busy || cartUnconfirmed) {event.preventDefault();bagError('Please wait while we confirm your bag. Reload if the update cannot be completed.');}
      return;
    }
    const form = event.target.closest('[data-native-product-form]');
    if (!form) return;
    // Both entry points share one guarded add; Shopify owns the wallet transaction.
    if (event.submitter && !['add','express'].includes(event.submitter.name)) return;
    event.preventDefault();
    if (busy || cartUnconfirmed) return;
    if (!syncProductForm(form)) {
      const error = $('[data-product-error]', form);
      error.textContent = 'Please choose an available size before adding this piece.';error.hidden = false;
      return;
    }
    if (!form.reportValidity()) return;
    const variant = $('[name="id"]', form)?.value;
    if (!variant) return;
    const error = $('[data-product-error]', form);
    error.hidden = true;
    setCartBusy(true);
    try {
      const added = await json(root + 'cart/add.js', {method: 'POST', headers: {'Content-Type': 'application/json'}, body: JSON.stringify({items: [{id: variant, quantity: 1}], sections: ['cart-drawer','main-cart'], sections_url: root + 'cart'})});
      await refreshBag(added.sections);setCartBusy(false);openDialog('bag', event.submitter);
      if (event.submitter?.name === 'express') {
        engage('ExpressCheckoutStarted');
        const wallets = $('[data-cart-wallets]', $('#cfa-bag'));
        if (wallets?.tagName === 'DETAILS') wallets.open = true;
        wallets?.scrollIntoView({block:'nearest'});wallets?.focus({preventScroll:true});
      }
    } catch (e) {
      try {await refreshBag();} catch {cartUnconfirmed = true;}
      if (e.unconfirmedMutation) cartUnconfirmed = true;
      error.textContent = e.message + ' Check your bag before adding again.';error.hidden = false;
    } finally {setCartBusy(false);}
  }, {capture: true});
  async function changeCart(key, value, trigger, remove = false) {
    const quantity = remove ? 0 : Number(value);
    if (busy || cartUnconfirmed || (!remove && (!/^[1-9]\d*$/.test(String(value)) || quantity > 250))) {
      if (!remove) trigger.value = trigger.dataset.confirmedQuantity;
      bagError(busy || cartUnconfirmed ? 'Please wait while we confirm your bag.' : 'Enter a whole number from 1 to 250. Use Remove to remove a piece.');
      return;
    }
    bagError('Updating your bag...');setCartBusy(true);
    const previousItem = engagementCart?.items.find(item => item.key === key);
    try {
      const changed = await json(root + 'cart/change.js', {method: 'POST', headers: {'Content-Type': 'application/json'}, body: JSON.stringify({id: key, quantity, sections: ['cart-drawer','main-cart'], sections_url: root + 'cart'})});
      const cart = await refreshBag(changed.sections);
      if ((cart.items.find(item => item.key === key)?.quantity || 0) === quantity) {
        const item = cart.items.find(item => item.key === key) || previousItem;
        const id = String(item?.variant_id || key.split(':')[0]);
        engage(remove ? 'CartItemRemoved' : 'CartQuantityChanged', {source:'bag',quantity,content_ids:/^\d+$/.test(id)?[id]:[],content_type:'product',currency:cart.currency,cart_value:cart.total_price / 100,item_count:cart.item_count,...(item ? {price:item.final_price / 100,value:item.final_price / 100} : {})});
      }
      bagError((cart.items.find(item => item.key === key)?.quantity || 0) === quantity ? '' : 'The available quantity has changed. Please review your bag.');
      $('#BagTitle')?.setAttribute('tabindex', '-1');$('#BagTitle')?.focus();
    } catch (e) {
      // A failed response can follow a successful write. Read back; never replay it.
      try {await refreshBag();} catch {cartUnconfirmed = true;}
      if (e.unconfirmedMutation) cartUnconfirmed = true;
      bagError(e.message + (cartUnconfirmed ? ' Reload to confirm your bag before checkout.' : ' Your confirmed bag is shown.'));
    } finally {setCartBusy(false);}
  }
  document.addEventListener('change', event => {
    const el = event.target;
    if (el.matches('[data-native-variant]')) {
      if (!el.closest('[data-quick-content]')) {variantChosen = true;engage('SwatchClicked', {size:el.selectedOptions[0]?.textContent.trim()});}
      const price = el.selectedOptions[0]?.dataset.price;
      const scope = el.closest('[data-quick-content]') || document;
      for (const p of $$('[data-native-price]', scope)) if (price) p.textContent = price;
      for (const p of $$('[data-native-compare]', scope)) {p.textContent = el.selectedOptions[0]?.dataset.compare || '';p.hidden = !p.textContent;}
      if (scope === document && el.value) {const url = new URL(location.href);url.searchParams.set('variant', el.value);history.replaceState({}, '', url);}
      const form = el.closest('[data-native-product-form]');
      if (form) {syncProductForm(form);const error = $('[data-product-error]', form);if (error) error.hidden = true;}
      updateAtelierEnquiry();
    }
    if (el.matches('[data-cart-quantity]')) changeCart(el.dataset.cartQuantity, el.value, el);
    if (el.matches('[data-sort]')) {const url = new URL(location.href);url.searchParams.set('sort_by', el.value);url.searchParams.delete('page');location.assign(url);}
    if (el.matches('[data-measurement-unit]')) {
      const table = $('[data-size-table]');
      for (const cell of $$('[data-measurement]', table)) cell.textContent = cell.dataset.measurement.replace(/\d+(?:\.\d+)?/g, n => el.value === table.dataset.originalUnit ? n : String(Math.round(Number(n) * (el.value === 'in' ? 1 / 2.54 : 2.54) * 10) / 10));
    }
  });
  let searchTimer;
  document.addEventListener('input', event => {
    if (event.target.matches('[data-faq-search]')) {const query = event.target.value.toLowerCase();for (const button of $$('[data-faq-category]')) button.setAttribute('aria-pressed','false');for (const item of $$('[data-faq-question]')) item.hidden = !item.textContent.toLowerCase().includes(query);return;}
    if (!event.target.matches('[data-predictive-search]')) return;
    clearTimeout(searchTimer);searchController?.abort();
    const term = event.target.value.trim(), results = $('[data-search-results]');results.replaceChildren();
    if (term.length < 2) return;
    searchTimer = setTimeout(async () => {
      const controller = new AbortController();searchController = controller;
      try {
        const data = await json(root + 'search/suggest.json?q=' + encodeURIComponent(term) + '&resources[type]=product&resources[limit]=6', {signal: controller.signal});
        if (controller !== searchController || controller.signal.aborted || $('[data-predictive-search]').value.trim() !== term) return;
        for (const product of data.resources.results.products) {if (!approvedHandles.has(product.handle)) continue;const a = document.createElement('a');a.href = product.url;a.textContent = product.title;results.append(a);}
        if (!results.children.length) results.textContent = 'No matching pieces. Try another print or category.';
      } catch (e) {if (e.name !== 'AbortError' && controller === searchController && !controller.signal.aborted && $('[data-predictive-search]').value.trim() === term) results.textContent = 'Press Search to see the full results.';}
    }, 220);
  });
  const edNode = $('[data-editorial]');
  let editorial, photoIndex = 0, zoomIndex = 0;
  try {if (edNode) editorial = JSON.parse(edNode.textContent);} catch {status('Photograph navigation is unavailable.');}
  if (editorial?.type === 'bandana') $('.immersive-hero')?.classList.add('cfa-location-gallery');
  const mobile = matchMedia('(max-width: 767px)');
  const responsiveCampaign = $('[data-responsive-campaign]');
  let photoRequest = 0, zoomRequest = 0;
  function campaignSource(img, shot, sizes) {
    const base = new URL(shot.original || shot.src, location.href);
    const widths = [320,480,640,800,960,1280,1600,1920,2560].filter(width => width <= shot.width);
    const share = mobile.matches ? 1 : (parseFloat(sizes) || 50) / 100;
    const target = innerWidth * share * (devicePixelRatio || 1);
    base.searchParams.set('width', widths.find(width => width >= target) || widths.at(-1));
    // Detached srcset images can change requests during decode in WebKit.
    // Select the correct density once for this transition; SSR keeps native srcset.
    img.removeAttribute('srcset');img.removeAttribute('sizes');img.src = base.href;
  }
  $('[data-zoom-toggle]')?.addEventListener('pointermove', event => {const rect=event.currentTarget.getBoundingClientRect();event.currentTarget.style.setProperty('--zoom-x',((event.clientX-rect.left)/rect.width*100)+'%');event.currentTarget.style.setProperty('--zoom-y',((event.clientY-rect.top)/rect.height*100)+'%');});
  function photoMarkup(shot, wide, index, sizes = '(max-width: 767px) 100vw, 50vw') {
    const button = document.createElement('button');button.className = 'immersive-photo';button.type = 'button';button.dataset.wide = String(wide);button.dataset.photoIndex = index;button.setAttribute('aria-label', `Enlarge photograph ${index + 1}`);
    if (shot.subjectWidth) button.style.setProperty('--subject-width-inverse', String(1 / shot.subjectWidth));
    const img = document.createElement('img');img.loading = 'eager';img.fetchPriority = responsiveCampaign ? 'auto' : 'high';
    if (responsiveCampaign) campaignSource(img, shot, sizes);else img.src = shot.src;
    img.alt = shot.alt;img.width = shot.previewWidth || shot.width;img.height = wide ? Math.round((shot.previewWidth || shot.width) * shot.height / shot.width) : shot.previewWidth || shot.height;img.decoding = 'async';img.draggable = false;
    if (editorial.type === 'glove') {button.style.setProperty('--photo-ratio', String(shot.width / shot.height));img.height = shot.height;}
    if (editorial.type === 'tote') {button.style.setProperty('--photo-ratio', String(shot.width / shot.height));img.height = Math.round(img.width * shot.height / shot.width);}
    if (shot.contain) img.dataset.contain = 'true';if (shot.detail) img.dataset.detail = 'true';button.append(img);return button;
  }
  async function showPhoto(index) {
    if (!editorial) return;
    photoIndex = Math.max(0, Math.min(editorial.shots.length - 1, index));
    const frames = $('.immersive-frames');if (!frames) return;
    const request = ++photoRequest, targetIndex = photoIndex;
    let items;
    let frameRatio, singleRatio;
    if (editorial.type === 'glove' || editorial.type === 'tote') {
      // Adjacent original aspect ratios share the width without cropping or gutters.
      const start = mobile.matches ? photoIndex : Math.min(photoIndex, Math.max(0, editorial.shots.length - 2));
      const visible = editorial.shots.slice(start, start + (mobile.matches ? 1 : 2));
      frameRatio = visible.reduce((sum, shot) => sum + shot.width / shot.height, 0);
      singleRatio = visible[0].width / visible[0].height;
      items = visible.map((shot, i) => photoMarkup(shot, false, start + i, mobile.matches ? '100vw' : `${shot.width / shot.height / frameRatio * 100}vw`));
    }
    else if (!mobile.matches && photoIndex === 0 && !editorial.leadPair) items = [photoMarkup(editorial.wide, true, 0)];
    else {items = [photoMarkup(editorial.shots[photoIndex], false, photoIndex)];if (!mobile.matches && !editorial.shots[photoIndex].detail && editorial.shots[photoIndex + 1]) items.push(photoMarkup(editorial.shots[photoIndex + 1], false, photoIndex + 1));}
    if (responsiveCampaign) {
      // Keep the approved current photo on screen until its replacement is decoded.
      frames.setAttribute('aria-busy', 'true');
      try {await Promise.all(items.map(item => $('img', item).decode()));}
      catch {if (request === photoRequest) {frames.setAttribute('aria-busy', 'false');photoIndex = Number(frames.dataset.photoIndex || 0);status('This photograph could not load. Please try again.');}return;}
      if (request !== photoRequest) return;
    }
    if (frameRatio) {$('.immersive-hero').style.setProperty('--frame-ratio', String(frameRatio));$('.immersive-hero').style.setProperty('--single-ratio', String(singleRatio));}
    frames.dataset.count = String(items.length);frames.dataset.photoIndex = targetIndex;frames.replaceChildren(...items);frames.setAttribute('aria-busy', 'false');
    const hero = $('.immersive-hero');hero.dataset.paired = String(items.length === 2);
    $('.immersive-prev', hero).disabled = photoIndex === 0;$('.immersive-next', hero).disabled = photoIndex === editorial.shots.length - 1;
    $$('.immersive-thumbnails button').forEach((button, i) => button.setAttribute('aria-pressed', String(i === photoIndex)));
    $('.immersive-hero > [aria-live]')?.replaceChildren(document.createTextNode(`Photograph ${photoIndex + 1} of ${editorial.shots.length}`));
  }
  function zoom(index) {
    if (!editorial) return;
    zoomRequest++;
    zoomIndex = Math.max(0, Math.min(editorial.shots.length - 1, index));
    const shot = editorial.shots[zoomIndex], img = $('[data-zoom-image]');
    if (responsiveCampaign) campaignSource(img, shot, '100vw');else img.src = shot.original;
    img.alt = shot.alt;
    $('#cfa-zoom').dataset.category = editorial.type || '';
    const previous = $('[data-zoom-prev]'), next = $('[data-zoom-next]'), toggle = $('[data-zoom-toggle]');
    if (previous) previous.disabled = zoomIndex === 0;if (next) next.disabled = zoomIndex === editorial.shots.length - 1;
    $('#cfa-zoom').dataset.zoomed = 'false';if (toggle) {toggle.setAttribute('aria-label','Zoom in');toggle.setAttribute('aria-pressed','false');}
    if (!$('#cfa-zoom').open) openDialog('zoom', document.activeElement);
  }
  async function loadOriginalZoom() {
    const request = ++zoomRequest, shot = editorial.shots[zoomIndex], full = new Image();
    full.src = shot.original;
    try {
      await full.decode();
      const dialog = $('#cfa-zoom');
      if (request !== zoomRequest || !dialog.open || dialog.dataset.zoomed !== 'true') return;
      const img = $('[data-zoom-image]');img.removeAttribute('srcset');img.removeAttribute('sizes');img.src = full.src;
    } catch {if (request === zoomRequest) status('The full-resolution photograph could not load. The preview is still available.');}
  }
  if (editorial && $('.immersive-pdp')) {
    const pdp = $('.immersive-pdp');pdp.dataset.category = editorial.type;if (editorial.setting) pdp.dataset.setting = editorial.setting;
    // Reuse server-rendered responsive images instead of restarting their downloads.
    if (!responsiveCampaign && (mobile.matches || editorial.leadPair)) showPhoto(0);
    mobile.addEventListener('change', () => showPhoto(photoIndex));
    let start;
    $('.immersive-frames')?.addEventListener('touchstart', event => {start = event.touches[0].clientX;}, {passive: true});
    $('.immersive-frames')?.addEventListener('touchend', event => {const d = start - event.changedTouches[0].clientX;if (Math.abs(d) > 55) showPhoto(photoIndex + (d > 0 ? 1 : -1));}, {passive: true});
  }
  const gloveGallery = $('[data-glove-gallery]');
  let gloveIndex = 0;
  function gloveState(index, scroll = true) {
    if (!gloveGallery) return;
    const images = $$('[data-glove-image]', gloveGallery), track = $('[data-glove-track]', gloveGallery), count = mobile.matches ? 1 : 2;
    gloveIndex = Math.max(0, Math.min(images.length - 1, index));
    const first = Math.floor(gloveIndex / count) * count;
    if (scroll) track.scrollTo({left: images[first].offsetLeft - images[0].offsetLeft, behavior: 'instant'});
    for (const [i, image] of images.entries()) image.tabIndex = i >= first && i < first + count ? 0 : -1;
    $$('[data-glove-thumbnail]', gloveGallery).forEach((el, i) => el.setAttribute('aria-current', String(i === gloveIndex)));
    $('[data-glove-count]', gloveGallery).textContent = `${count === 1 ? 'View' : 'Views'} ${first + 1}${count === 2 && first + 1 < images.length ? ' - ' + Math.min(first + 2, images.length) : ''} / ${images.length}`;
    $('[data-glove-status]', gloveGallery).textContent = `Photograph ${gloveIndex + 1} of ${images.length}`;
    $('[data-glove-prev]', gloveGallery).disabled = first === 0;
    $('[data-glove-next]', gloveGallery).disabled = first + count >= images.length;
  }
  if (gloveGallery) {
    gloveState(0);mobile.addEventListener('change', () => gloveState(gloveIndex));
    new ResizeObserver(() => gloveState(gloveIndex)).observe($('[data-glove-track]', gloveGallery));
    $('[data-glove-track]', gloveGallery).addEventListener('scroll', () => {
      const images = $$('[data-glove-image]', gloveGallery), track = $('[data-glove-track]', gloveGallery), step = mobile.matches ? 1 : 2;
      const target = images.reduce((best, el, i) => i % step === 0 && Math.abs(el.offsetLeft - images[0].offsetLeft - track.scrollLeft) < Math.abs(images[best].offsetLeft - images[0].offsetLeft - track.scrollLeft) ? i : best, 0);
      if (Math.floor(gloveIndex / step) * step !== target) gloveState(target, false);
    }, {passive: true});
  }
  for (const rail of $$('[data-recommendation-rail]')) {
    const track = $('[data-recommendation-track]', rail), prev = $('[data-recommendation-prev]', rail), next = $('[data-recommendation-next]', rail);
    const update = () => {
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
      $('[data-recommendation-controls]', rail).hidden = prev.disabled && next.disabled;
    };
    const move = direction => track.scrollBy({left: direction * ((track.firstElementChild?.getBoundingClientRect().width || track.clientWidth) + (parseFloat(getComputedStyle(track).columnGap) || 0)), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
    prev.addEventListener('click', () => move(-1));next.addEventListener('click', () => move(1));
    track.addEventListener('scroll', update, {passive:true});new ResizeObserver(update).observe(track);update();
  }
  for (const trigger of $$('[data-open-bandana-fit]')) trigger.addEventListener('click', event => {
    const panel = $('#bandana-fit');if (!panel) return;
    event.preventDefault();panel.open = true;panel.scrollIntoView({behavior: 'instant', block: 'center'});$('summary', panel)?.focus({preventScroll:true});
  });
  function studyTab(name, focus = false) {
    for (const tab of $$('[data-study-tab]')) {
      const active = tab.dataset.studyTab === name;
      tab.setAttribute('aria-selected', String(active));tab.dataset.state = active ? 'active' : 'inactive';tab.tabIndex = active ? 0 : -1;
      $('#' + tab.getAttribute('aria-controls')).hidden = !active;
      if (focus && active) tab.focus();
    }
  }
  const calendar = new Date(), today = `${calendar.getFullYear()}-${String(calendar.getMonth() + 1).padStart(2,'0')}-${String(calendar.getDate()).padStart(2,'0')}`;
  const arrival = new Date(today + 'T12:00:00Z');arrival.setUTCDate(arrival.getUTCDate() + 10);
  const arrivalDay = arrival.toISOString().slice(0,10);
  function updateArrivalDates() {
    const date=new Date(),localDay=`${date.getFullYear()}-${String(date.getMonth()+1).padStart(2,'0')}-${String(date.getDate()).padStart(2,'0')}`;
    const estimated=new Date(localDay+'T12:00:00Z');estimated.setUTCDate(estimated.getUTCDate()+10);
    for (const el of $$('[data-arrival-date]')) {el.dateTime=estimated.toISOString().slice(0,10);el.textContent=new Intl.DateTimeFormat('en-US',{month:'short',day:'numeric',year:'numeric',timeZone:'UTC'}).format(estimated);}
  }
  updateArrivalDates();
  function menuTab(dialog,name,focus=false) {
    for (const tab of $$('[data-menu-tab]',dialog)) {
      const active=tab.dataset.menuTab===name;tab.setAttribute('aria-selected',String(active));tab.dataset.state=active?'active':'inactive';tab.tabIndex=active?0:-1;
      const panel=document.getElementById(tab.getAttribute('aria-controls'));if(panel)panel.hidden=!active;
      if(active&&focus)tab.focus();
    }
  }
  for(const dialog of $$('[data-menu-initial]'))menuTab(dialog,dialog.dataset.menuInitial);
  for(const mark of $$('[data-menu-wordmark]')){const original=$('.house-header .house-wordmark-art');if(original){mark.replaceChildren(original.cloneNode(true));mark.setAttribute('aria-label','Creo Fleur Atelier home');}}
  document.addEventListener('keydown',event=>{const tab=event.target.closest('[data-menu-tab]');if(!tab||!['ArrowLeft','ArrowRight','Home','End'].includes(event.key))return;event.preventDefault();menuTab(tab.closest('dialog'),event.key==='Home'?'shop':event.key==='End'?'atelier':tab.dataset.menuTab==='shop'?'atelier':'shop',true);});
  function updateAtelierEnquiry() {
    const date = $('[data-event-date]')?.value, option = $('[data-native-variant]')?.selectedOptions[0];
    const handle = $('[data-native-product]')?.dataset.handle;
    const links = $$('a[href]').filter(link => link.hasAttribute('data-atelier-enquiry') || handle && new URL(link.href).searchParams.get('product') === handle && new URL(link.href).searchParams.get('source') === 'pdp');
    for (const link of links) {
      const url = new URL(link.href);
      if (date) url.searchParams.set('eventDate', date);else url.searchParams.delete('eventDate');
      if (option?.value) {url.searchParams.set('variant', option.value);url.searchParams.set('size', option.textContent.trim());url.searchParams.set('variantTitle', option.textContent.trim());}
      else {url.searchParams.delete('variant');url.searchParams.delete('size');url.searchParams.delete('variantTitle');}
      url.searchParams.set('timezone', Intl.DateTimeFormat().resolvedOptions().timeZone);
      link.href = url;
    }
  }
  const eventDate = $('[data-event-date]');
  if (eventDate) {
    eventDate.min = today;
    eventDate.addEventListener('change', () => {
      $('[data-event-status]').textContent = !eventDate.value ? '' : eventDate.value < arrivalDay ? 'Your event is before the estimated arrival day. Ask the atelier before ordering; earlier delivery is not confirmed.' : eventDate.value === arrivalDay ? 'Your event is on the estimated arrival day and may be too close. Ask the atelier before ordering.' : 'The estimated arrival is before your event. Arrival by this date is not guaranteed.';
      updateAtelierEnquiry();
    });
  }
  updateAtelierEnquiry();
  const enquiryBody = $('[name="contact[body]"]'), enquirySubject = $('[name="contact[subject]"]');
  if (enquiryBody && !enquiryBody.value) {
    const params = new URLSearchParams(location.search), product = params.get('product'), piece = params.get('piece');
    if (/^[a-z0-9]+(?:-[a-z0-9]+)*$/.test(product || '') && product.length <= 160 && piece && piece.length <= 200) {
      const safe = key => (params.get(key) || '').replace(/[\x00-\x1f\x7f]/g, '').slice(0,200);
      const questions = {piece:'I would like to know more about this piece.',fabric:'Could you tell me more about the fabric and how it feels?',fit:'Could you help me choose the right size and fit?',care:'How should I care for this piece?'};
      const lines = [questions[params.get('topic')] || questions.piece, '', 'Piece: '+safe('piece'), 'Product: '+product];
      for (const [key,label] of [['variant','Variant'],['size','Size'],['eventDate','Event date'],['timezone','Time zone']]) if (safe(key)) lines.push(label+': '+safe(key));
      enquiryBody.value = lines.join('\n');if (enquirySubject && !enquirySubject.value) enquirySubject.value = safe('piece');
    }
  }
  document.addEventListener('keydown', event => {
    if (event.target.matches('[data-study-tab]') && ['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) {
      event.preventDefault();const tabs = $$('[data-study-tab]'), current = tabs.indexOf(event.target);
      const next = event.key === 'Home' ? 0 : event.key === 'End' ? tabs.length - 1 : (current + (event.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
      studyTab(tabs[next].dataset.studyTab, true);return;
    }
    const activeDialog = $('dialog[open]');
    if (event.key === 'Tab' && activeDialog) {
      const controls = $$('a[href],button:not([disabled]),input:not([disabled]):not([type="hidden"]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])', activeDialog).filter(el => el.getClientRects().length && getComputedStyle(el).visibility !== 'hidden');
      event.preventDefault();
      if (!controls.length) return;
      const index = activeDialog.contains(document.activeElement) ? controls.indexOf(document.activeElement) : -1;
      const next = event.shiftKey ? (index <= 0 ? controls.length - 1 : index - 1) : (index + 1) % controls.length;
      controls[next].focus();
    }
    if (event.key === 'Escape' && $('dialog[open]')) {event.preventDefault();$('dialog[open]').close();return;}
    if ($('#cfa-zoom')?.open && ['ArrowLeft', 'ArrowRight'].includes(event.key)) {event.preventDefault();zoom(zoomIndex + (event.key === 'ArrowRight' ? 1 : -1));}
  }, true);
  async function quickView(url, trigger) {
    quickController?.abort();
    const controller = new AbortController();quickController = controller;
    const target = $('[data-quick-content]');target.textContent = 'Loading this piece...';openDialog('quick', trigger);
    let timedOut = false;
    const timer = setTimeout(() => {timedOut = true;controller.abort();}, 20000);
    try {
      const response = await fetch(url + (url.includes('?') ? '&' : '?') + 'section_id=main-product', {credentials: 'same-origin', signal: controller.signal});
      if (!response.ok) throw Error('Quick view unavailable');
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      if (controller !== quickController || controller.signal.aborted || !$('#cfa-quick').open) return;
      let buy = $('.immersive-buy', doc);
      const glove = $('.pdp-buybox', doc);
      if (!buy && glove) {
        buy = document.createElement('div');buy.className = 'immersive-buy';
        const heading = document.createElement('h2');heading.textContent = $('.pdp-title', glove)?.textContent || '';
        const price = $('[data-native-price]', glove)?.cloneNode(true), form = $('[data-native-product-form]', glove)?.cloneNode(true);
        if (!price || !form) throw Error('Quick view unavailable');
        $('.pdp-decision-facts', form)?.remove();buy.append(heading, price, form);
      }
      if (!buy) throw Error('Quick view unavailable');
      buy.querySelector('[data-open-dialog="size"]')?.remove();buy.querySelectorAll('[id]').forEach(e => e.id = 'quick-' + e.id);buy.querySelectorAll('[for]').forEach(e => e.htmlFor = 'quick-' + e.htmlFor);
      target.replaceChildren(buy);const a = document.createElement('a');a.href = url;a.dataset.fullProduct = '';a.textContent = 'View the full piece';target.append(a);
      for (const form of $$('[data-native-product-form]', target)) syncProductForm(form);
    } catch {
      if (controller !== quickController || (controller.signal.aborted && !timedOut) || !$('#cfa-quick').open) return;
      target.textContent = '';const a = document.createElement('a');a.href = url;a.textContent = 'View this piece';target.append(a);
    } finally {clearTimeout(timer);}
  }
  document.addEventListener('click', async event => {
    const el = event.target.closest('button,a');if (!el) return;
    if (el.dataset.storyChoice !== undefined) {for (const panel of $$('[data-story-panel]')) panel.hidden = panel.dataset.storyPanel !== el.dataset.storyChoice;for (const button of $$('[data-story-choice]')) {button.setAttribute('aria-pressed', String(button === el));button.style.opacity = button === el ? '1' : '.5';}}
    if (el.dataset.journalFilter) {for (const article of $$('[data-journal-category]')) article.hidden = el.dataset.journalFilter !== 'All' && article.dataset.journalCategory !== el.dataset.journalFilter;for (const button of $$('[data-journal-filter]')) button.setAttribute('aria-pressed', String(button === el));}
    if (el.dataset.faqCategory) {const all = el.getAttribute('aria-pressed') === 'true';$('[data-faq-search]').value = '';for (const item of $$('[data-faq-question]')) item.hidden = !all && item.dataset.faqGroup !== el.dataset.faqCategory;for (const button of $$('[data-faq-category]')) button.setAttribute('aria-pressed', String(!all && button === el));$('[data-faq-question]:not([hidden])')?.scrollIntoView({block:'center'});}
    if (el.dataset.fallChoice !== undefined) {
      const container = el.closest('[data-fall-switch]'), choices = JSON.parse($('[data-fall-images]').textContent)[Number(container.dataset.fallSwitch)], shot = choices[Number(el.dataset.fallChoice)], image = new Image(), message = $('.fall-view-status', container);
      image.src = shot.src;image.srcset = shot.srcSet;image.sizes = '(min-width: 900px) 50vw, 100vw';image.width = shot.width;image.height = shot.height;image.alt = shot.alt;message.textContent = 'Opening view...';el.disabled = true;
      try {await image.decode();$('picture', container).replaceChildren(image);await image.decode();$$('[data-fall-choice]', container).forEach(button => button.setAttribute('aria-pressed', String(button === el)));$('.fall-photo-index', container).textContent = Number(el.dataset.fallChoice) ? '02 / 02' : '01 / 02';message.textContent = '';}
      catch {message.textContent = 'This view could not load. Please try again.';}finally {el.disabled = false;}
    }
    if (/^(Next|Previous) (bombers|kimonos)$/.test(el.getAttribute('aria-label') || '')) {const rail = $('.fall-product-rail', el.closest('.fall-selection'));rail?.scrollBy({left: (/Next/.test(el.getAttribute('aria-label')) ? 1 : -1) * rail.clientWidth * .8, behavior: 'smooth'});}
    if (el.dataset.openDialog) {event.preventDefault();if (el.dataset.openDialog === 'bag') {try {await refreshBag();} catch {location.assign(root + 'cart');return;}}openDialog(el.dataset.openDialog, el);}
    if (el.hasAttribute('data-close-dialog')) el.closest('dialog')?.close();
    if (el.hasAttribute('data-glove-thumbnail')) gloveState(Number(el.dataset.gloveThumbnail));
    if (el.hasAttribute('data-glove-prev')) gloveState(Math.floor(gloveIndex / (mobile.matches ? 1 : 2)) * (mobile.matches ? 1 : 2) - (mobile.matches ? 1 : 2));
    if (el.hasAttribute('data-glove-next')) gloveState(Math.floor(gloveIndex / (mobile.matches ? 1 : 2)) * (mobile.matches ? 1 : 2) + (mobile.matches ? 1 : 2));
    if (el.hasAttribute('data-glove-image')) zoom(Number(el.dataset.gloveImage));
    if (el.hasAttribute('data-study-tab')) studyTab(el.dataset.studyTab);
    if (el.hasAttribute('data-menu-tab')) menuTab(el.closest('dialog'),el.dataset.menuTab);
    if (el.hasAttribute('data-zoom-toggle')) {const d=$('#cfa-zoom'), active=d.dataset.zoomed!=='true';d.dataset.zoomed=String(active);el.setAttribute('aria-pressed',String(active));el.setAttribute('aria-label',active?'Zoom out':'Zoom in');if (responsiveCampaign && active) loadOriginalZoom();}
    if (el.hasAttribute('data-scroll-purchase')) {$('#dress-details')?.scrollIntoView({behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});$('[data-native-variant]')?.focus({preventScroll: true});}
    if (el.dataset.cartRemove) {event.preventDefault();changeCart(el.dataset.cartRemove, 0, el, true);}
    if (el.dataset.cartStep) {event.preventDefault();const input=$('[data-cart-quantity]',el.closest('.cfa-cart-line'));if(input)changeCart(input.dataset.cartQuantity,String(Number(input.dataset.confirmedQuantity)+Number(el.dataset.cartStep)),input);}
    if (el.dataset.quickView) quickView(el.dataset.quickView, el);
    if (el.hasAttribute('data-filter-toggle')) {const filters = $('[data-filters]');filters.hidden = !filters.hidden;el.setAttribute('aria-expanded', String(!filters.hidden));}
    if (el.dataset.density) {const grid = $('[data-product-grid]');if (grid) grid.dataset.density = el.dataset.density;for (const button of $$('button[data-density]')) button.setAttribute('aria-pressed', String(button === el));}
    if (el.hasAttribute('data-card-alternate')) {const img = $('img[data-alternate]', el.closest('[data-product-card]'));if (img) {const prev = img.src;img.src = img.dataset.alternate;img.dataset.alternate = prev;el.textContent = el.textContent.includes('01 /') ? '02 / 02' : '01 / 02';}}
    if (el.closest('.immersive-thumbnails')) showPhoto($$('.immersive-thumbnails button').indexOf(el));
    if (el.matches('.immersive-hero > .immersive-next')) showPhoto(photoIndex + 1);
    if (el.matches('.immersive-hero > .immersive-prev')) showPhoto(photoIndex - 1);
    if (el.matches('.immersive-photo')) zoom(Number(el.dataset.photoIndex || photoIndex));
    if (el.hasAttribute('data-image-zoom')) {const source = $('img', el), img = $('[data-zoom-image]');img.src = source.src;img.alt = source.alt;openDialog('zoom', el);}
    if (el.hasAttribute('data-zoom-prev')) zoom(zoomIndex - 1);
    if (el.hasAttribute('data-zoom-next')) zoom(zoomIndex + 1);
    if (el.dataset.sizeChoice) {const select = $('[data-native-variant]');const option = [...select.options].find(o => o.textContent.trim() === el.dataset.sizeChoice || o.textContent.startsWith(el.dataset.sizeChoice + ' /'));if (option && !option.disabled) {select.value = option.value;select.dispatchEvent(new Event('change', {bubbles: true}));el.closest('dialog').close();select.focus();}}
    if (el.hasAttribute('data-privacy-preferences')) {event.preventDefault();openDialog('privacy', el);}
    if (el.hasAttribute('data-consent-all')) consent(true, true);
    if (el.hasAttribute('data-consent-none')) consent(false, false);
    if (el.hasAttribute('data-consent-save')) consent($('[data-consent-analytics]').checked, $('[data-consent-marketing]').checked);
    if (/^(Next|Previous) categories$/.test(el.getAttribute('aria-label') || '')) $('.home-category-track')?.scrollBy({left: /Next/.test(el.getAttribute('aria-label')) ? 350 : -350, behavior: 'smooth'});
  });
  function consent(analytics, marketing) {
    const privacy = window.Shopify?.customerPrivacy;
    if (!privacy) { $('[data-consent-error]').textContent = 'Privacy settings could not be saved. Please reload and try again.';return; }
    privacy.setTrackingConsent({analytics, marketing, preferences: analytics}, result => {
      if (result?.error) {openDialog('privacy', document.activeElement);$('[data-consent-error]').textContent = 'Privacy settings could not be saved. Please try again.';return;}
      $('[data-privacy-banner]').hidden = true;$('#cfa-privacy').close();status('Privacy preferences saved.');
    });
  }
  function privacyReady() {
    const api = window.Shopify?.customerPrivacy;
    if (api) $('[data-privacy-banner]').hidden = !api.shouldShowBanner();
    startEngagement();
  }
  function syncPrivacyChoices() {
    const current = window.Shopify?.customerPrivacy?.currentVisitorConsent();
    $('[data-consent-analytics]').checked = current?.analytics === 'yes';
    $('[data-consent-marketing]').checked = current?.marketing === 'yes';
    $('[data-consent-error]').textContent = '';
  }
  for (const form of $$('[data-native-product-form]')) syncProductForm(form);
  if (window.Shopify?.loadFeatures) window.Shopify.loadFeatures([{name: 'consent-tracking-api', version: '0.1'}], error => {if (!error) privacyReady();});
  for (const rail of $$('.fall-product-rail')) {const controls = $('.fall-rail-controls', rail.closest('.fall-selection'));const update = () => {const buttons = $$('button', controls);buttons[0].disabled = rail.scrollLeft < 2;buttons[1].disabled = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 2;};rail.addEventListener('scroll', update, {passive: true});new ResizeObserver(update).observe(rail);update();}
  const header = $('.house-header'), hero = $('.house-hero,.immersive-hero,.fall-cover');
  function scrollState() {
    if (header) {
      const below = document.elementFromPoint(innerWidth / 2, header.getBoundingClientRect().bottom + 1);
      // The mobile home header sits above the photo on a white category strip.
      const mobileHome = mobile.matches && hero?.classList.contains('house-hero');
      const productPage = document.body.dataset.template === 'product';
      const over = !mobileHome && !productPage && !!(hero && below && hero.contains(below));
      const darkGlove = !mobile.matches && !!$('.cfa-glove-pdp');
      const light = darkGlove || over && !!$('.house-hero,.fall-cover');
      header.dataset.surface = over ? 'hero' : 'solid';header.dataset.tone = light ? 'light' : 'dark';
      header.style.background = darkGlove ? '#110f0e' : over ? 'transparent' : '#fff';header.style.color = light ? '#fff' : '#181916';
    }
    const bar = $('[data-mobile-purchase]'), buy = $('.immersive-buy, .pdp-buybox'), footer = $('footer');
    if (bar && buy) {const r = buy.getBoundingClientRect();bar.hidden = r.bottom > 0 || footer.getBoundingClientRect().top < innerHeight || !!$('dialog[open]');}
  }
  addEventListener('scroll', scrollState, {passive: true});scrollState();
  if (header) new ResizeObserver(() => {document.documentElement.style.setProperty('--cfa-header-height', header.offsetHeight + 'px');scrollState();}).observe(header);
})();
